import { Outlet } from "react-router-dom"
import { Container } from "@mui/material"
import Header from "../Header"

const ToolsLayout = () => {
  return (
    <>
      <Header
        logoUrl="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-NEklmR3dJgSvNjmf6kh91GoRFr97d5.png"
        onSearch={() => { }}
        searchTerm=""
      />
      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <Outlet />
      </Container>
    </>
  )
}

export default ToolsLayout
